var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminderIconCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7744 14.4928L17.3746 14.6195L21.3471 16.6462C22.014 16.8703 22.4522 17.5426 22.395 18.2636V18.5169L21.5376 24.48C21.4805 24.899 21.2995 25.2887 20.966 25.5615C20.6707 25.8538 20.2801 26 19.8705 26H13.3163C12.8495 26 12.4208 25.8246 12.1064 25.4836L6.40002 19.6667L7.25741 18.6923C7.48605 18.4487 7.84805 18.3123 8.19101 18.3318H8.46728L12.2493 19.1795V8.94872C12.2493 8.43189 12.45 7.93622 12.8073 7.57077C13.1647 7.20531 13.6493 7 14.1546 7C14.6599 7 15.1445 7.20531 15.5019 7.57077C15.8592 7.93622 16.0599 8.43189 16.0599 8.94872V14.4928H16.7744Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3006 3.08253C13.555 2.97249 14.8449 2.97249 16.0993 3.08253M19.798 3.7708C20.8599 4.09391 21.773 4.50633 22.4871 4.98539M24.0165 6.64533C24.2611 7.20983 24.2611 7.79026 24.0165 8.35475M22.4871 10.0192C21.7691 10.4971 20.8526 10.908 19.788 11.2293M16.0993 11.9176C14.8448 12.0275 13.5551 12.0275 12.3006 11.9176M8.60189 11.2293C7.53999 10.9062 6.62689 10.4938 5.91282 10.0147M4.38335 8.35475C4.13882 7.79026 4.13882 7.20983 4.38335 6.64533M5.91282 4.98089C6.63083 4.50303 7.54733 4.09213 8.61189 3.7708",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIconCustom);
export default __webpack_public_path__ + "static/media/reminder_icon_custom.5c726d596735097f9deeba5fc7a07034.svg";
export { ForwardRef as ReactComponent };